import React from 'react'
import { useI18next, useTranslation } from '../../plugins/i18next/ea-react-i18next';
import Button from './Button';

const BookDemoButton = () => {
    const { t } = useTranslation("components", { keyPrefix: 'start.bookDemoButton' });
    const { i18n } = useI18next();
    const currentLanguage = i18n.language;
    return <Button text={t("bookDemo")} icon='flaticon-right' external={true} href={`https://calendly.com/easylife-365-demos-${currentLanguage}`} />
}


export default BookDemoButton